module.exports = __webpack_public_path__ + "static/slider-arrow-b771bb01ea80b257f15b434d1a561895.svg";